export default __webpack_public_path__ + "static/media/airlockz-cbb-banner-1.68eee10a.jpg";